import {Component, inject} from '@angular/core'
import {LoanTypePipe} from '../../../pipes/loan-type.pipe'
import {LoanService} from '../../../services/loan.service'
import {KalpItemComponent} from '../kalp-item/kalp-item.component'

@Component({
  selector: 'spb-kalp-loan-costs',
  templateUrl: './loan-costs.component.html',
  styleUrls: ['../kalp.component.scss'],
  imports: [KalpItemComponent, LoanTypePipe]
})
export class LoanCostsComponent {
  public readonly loanService = inject(LoanService)
}
